import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=a975c476&scoped=true&"
var script = {}
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=a975c476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a975c476",
  null
  
)

export default component.exports